import Vue from 'vue'
import get from 'lodash/get'
import template from './template'

let types = ['success', 'error', 'warning', 'info']
let saveMessages = {}
let eventAdded = false
types.forEach(type => { saveMessages[type] = [] })

const findById = (type, id) => {
  let found = -1
  saveMessages[type].forEach(function (message, index) {
    if (message.id === id) {
      found = index
    }
  })
  return found
}

export default {
  success (...args) { this.pop('success', ...args) },
  error (...args) { this.pop('error', ...args) },
  warning (...args) { this.pop('warning', ...args) },
  info (...args) { this.pop('info', ...args) },
  pop (type, message, elem, id, compile, callback) {
    if (type === 'error') {
      let error = get(message, 'response.data.message')
      error = error || get(message, 'response.data.error')
      error = error || get(message, 'response.statusText')
      message = error || message.message || message
    }
    message = Vue.prototype.$t(message)
    if (types.indexOf(type) === -1) {
      console.debug(`Message Block ${type} isn't a type`)
      return
    }
    if (id && (findById(type, id) !== -1)) {
      console.debug(`Message Block ${id} already exist`)
      return
    }

    const obj = {
      id,
      message,
      compile: compile || false
    }
    const findIndex = saveMessages[type].findIndex(block => block.message === message)
    if (findIndex === -1) {
      saveMessages[type].push(obj)
    }
    template.update(saveMessages, elem)
    let messageBlockElem = document.getElementById(template.id)
    if (messageBlockElem && !eventAdded) {
      messageBlockElem.addEventListener('mouseover', this.cancel.bind(this))
      messageBlockElem.addEventListener('mouseleave', this.enableTimer.bind(this, type, id, elem, callback))
      eventAdded = true
    }
    this.enableTimer(type, id, elem, callback)
  },
  enableTimer (type, id, elem, callback) {
    this.cancel()
    if (type !== 'alert' && type !== 'warning') {
      this.timer = setTimeout(() => {
        this.remove(type, id, elem)
        if (callback) { return callback(id) }
      }, 3000)
    }
  },
  remove (type, id, elem) {
    // Si on ne defini pas l'id, on supprime tout les messages
    if (!id) {
      saveMessages[type] = []
    }
    const element = findById(type, id)
    if (element !== -1) {
      saveMessages[type].splice(element, 1)
    }
    template.update(saveMessages, elem)
  },
  cancel () { clearTimeout(this.timer) }
}
